import { combineReducers, Reducer } from "@reduxjs/toolkit";
import auth from "./auth/index";
import config from "./config";
export const rootReducer: Reducer = combineReducers({
  auth,
  config,
});

export type RootState = ReturnType<typeof rootReducer>;
